const icones = {
  1: 'fa fa-clock-o status-aguardando',
  2: 'fa fa-exclamation-circle status-vencido',
  3: 'fa fa-check-circle status-liberado',
  4: 'fa fa-check-circle status-pago',
  5: 'fa fa-ban status-reprovado',
};

export function iconeStatus(codigo) {
  return icones[codigo] || '';
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-pagamento/status.js